import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      nav("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <Link to="/" className="text-xs tracking-[0.3em] uppercase text-[#C24D2C] link-underline">
            ← Back to site
          </Link>
          <h1 className="mt-6 font-serif-display text-4xl text-[#1A2456] font-bold">Admin Sign in</h1>
          <p className="mt-3 text-sm text-[#5C544F]">Manage publications, activities, gallery, blog and messages.</p>

          <form data-testid="login-form" onSubmit={submit} className="mt-10 space-y-5 bg-white border border-[#D8CFC4] p-8">
            <div>
              <label className="text-[10px] tracking-[0.3em] uppercase text-[#8A817C]">Email</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border border-[#D8CFC4] px-4 py-3 focus:outline-none focus:border-[#E35D29] focus:ring-1 focus:ring-[#E35D29]"
              />
            </div>
            <div>
              <label className="text-[10px] tracking-[0.3em] uppercase text-[#8A817C]">Password</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border border-[#D8CFC4] px-4 py-3 focus:outline-none focus:border-[#E35D29] focus:ring-1 focus:ring-[#E35D29]"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-[#E35D29] text-white py-3.5 hover:bg-[#C84B1D] transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
